import {Action} from '@ngrx/store';
import {BijbError} from '../../../models/bijb-error';

export class AddBijbEventErrorAction implements Action {
  public static readonly type = 'AddBijbEventErrorAction';

  constructor(public error: BijbError) {
  }

  public type = AddBijbEventErrorAction.type;
}
